import React from 'react'
import Icon from '../svg/Icon'

export interface IAccordionProps {
  heading: string
  children: React.ReactNode
  expanded?: boolean
  onClick: () => void
}
const Accordion = (props: IAccordionProps) => {
  // const [expanded, setExpanded] = useState(props.expanded || false)

  // useEffect(() => {
  //   setExpanded(props.expanded)
  // }, [props.expanded])

  const handleClick = () => {
    // props.onChange(!expanded)
    // setExpanded(!expanded)
    props.onClick()
  }

  const ariaLabel = props.expanded
    ? props.heading +
      '. This is an expanded accordion pane. Click to collapse it.'
    : props.heading +
      '. This is a collapsed accordion pane. Click to expand it.'
  return (
    <>
      <div className={props.expanded ? 'accordion is-open' : 'accordion'}>
        <div className="accordion-header">
          <h2 className="accordion-heading">{props.heading}</h2>
          <button
            type="button"
            aria-label={ariaLabel}
            className={
              props.expanded
                ? 'accordion-trigger js-accordion-trigger is-active'
                : 'accordion-trigger js-accordion-trigger'
            }
            onClick={handleClick}
          >
            <Icon name="chevron-down-solid" width="14" height="14" />
          </button>
        </div>
        <div className="accordion-body">{props.children}</div>
      </div>
    </>
  )
}

export default Accordion
